'use client';

import { useTranslations } from 'next-intl';

import { Link } from '@/i18n/navigation';
import { getPoolsLinkHref } from '@/lib/utils/pools';
import { useGlobalData } from '@/providers/GlobalDataProvider';
import { C_DEFAULT_404_POOL_LINK, C_Routes } from '@/ts/constants/C_Routes';
import { E_Routes } from '@/ts/enums/E_Routes';

interface I_FooterPoolsLinkProps {
  isNotFound?: boolean;
}

export function FooterPoolsLink({
  isNotFound = false
}: I_FooterPoolsLinkProps) {
  const t = useTranslations('footer');
  const pools = useGlobalData('pools');

  const poolsLink = getPoolsLinkHref(pools, {
    fallbackPresaleHref:
      C_Routes[E_Routes.POOLS_PRESALE]?.link || '/pools-presale'
  });

  return <Link href={poolsLink}>{t('pools')}</Link>;
}
